// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cmn_labels[data-v-580c744c]  .label-slt,.cmn_labels[data-v-580c744c]  .label-slt .el-form .el-form-item{margin-bottom:10px}.cmn_labels[data-v-580c744c]  .el-form .el-form-item{margin-bottom:0!important}", ""]);
// Exports
module.exports = exports;
